module.exports = __webpack_public_path__ + "assets/img/success_icon.2a257ac8.png";